import ClassenService from '../ClassenService';

class TranslationService {
  getTranslations() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/translations`);
  }

  getAllKeysWithTranslations() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/translations/all`);
  }

  addTranslation(translationData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/translations`, 'addTranslation', translationData);
  }

  getTranslation(translationId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/translations/${translationId}`);
  }

  updateTranslation(translationId, translationData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/translations/${translationId}`, 'updateTranslation', translationData);
  }

  deleteTranslation(translationId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/translations/${translationId}`, 'deleteTranslation');
  }
}

export default new TranslationService();
